__webpack_require__.p = "/schoolerp/";